import { Component, Inject, Optional } from "@angular/core";
import * as Immutable from "immutable";
import { PopupService } from "../../../../shared/components";
// Customization (modified)
import { ConfPriceValue, StoredPriceValue, PriceReportMessage, Conf, PriceOperationMessage, PriceSettingMessage, PriceCommand, RequestViews, StoredPriceReportMessage } from "../../../shared/models";
// End customization
import { ProductDataStore } from "../../../shared/providers/productData";
import { ConfiguratorStore, ConfMessageProvider, ConfPageSessionService, PopupIdentifiers } from "../../providers";
import { BaseDetailItemComponent } from "../shared/baseDetailItemComponent";
import { SummaryDisplayStyles } from "./SummaryDisplayStyle";

@Component({
  selector: 'prices-detail',
  templateUrl: './pricesDetailComponent.html',
})
export class PricesDetailComponent extends BaseDetailItemComponent {

  public confPriceValue: ConfPriceValue;
  // Customization
  confPriceValues: ConfPriceValue[] = [];
  settingsIcon: string = null;
  // End customization
  public storedPriceValue: StoredPriceValue;
  public showPriceType = false;
  public isCurrentPriceVisible = false;
  public isStoredPriceVisible = false;
  
  constructor( @Optional() @Inject(ConfPageSessionService) public storeSession: ConfPageSessionService,
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfMessageProvider) public confMessageProvider: ConfMessageProvider,
    @Inject(PopupService) public popupService: PopupService,
    @Inject(ProductDataStore) public productStore: ProductDataStore,
  ) {
    super(storeSession);
  }

  onDataReady(): void {
    
  }


  init(): void {

    if (!this.configurationId || !this.confSessionId)
      return;

    let conf = this.storeSession.activeConfiguration;
    this.confPriceValue = conf.priceValue;
    // Customization
    this.confPriceValues = this.getPriceValues(conf);
    if (conf.authorization.canChangeCurrency || conf.authorization.canChangePriceListCategory)
      this.settingsIcon = "settings";


    this.visible = this.confPriceValue != null || this.confPriceValues.length > 0;
    this.showPriceType = true;
    // End customization
  }

  // Customization
  public onDetailsClick($event, confPriceValue: ConfPriceValue): void {
    let requestType = this.confPageSessionService.confUIStore.PageStore.getActiveClientType();
    if (confPriceValue)
      this.getPriceReport(this.confSessionId, this.configurationId, confPriceValue.priceListCategoryId);
    else
      this.confStore.getPriceReport(this.confSessionId, this.configurationId, requestType);
  }
  // End customization

  subscribeDataChange(): void {
    // Customization
    // Price setting message
    this.confMessageProvider.onMessagesRequest<PriceSettingMessage>(this.storeSession.confSessionId, PriceSettingMessage.name, {
      next: (messages: Immutable.List<PriceSettingMessage>): void => {
        this.popupService.open<PriceSettingMessage>(PopupIdentifiers.PriceSetting, messages.get(0));
      },
      listenNewEventsOnly: true
    }).unsubscribeOn(this.unsubscribeSubject);  
    // End customization

    // Price report message
    this.confMessageProvider.onMessagesRequest<PriceReportMessage>(this.confPageSessionService.confSessionId, PriceReportMessage.name, {
      next: (messages: Immutable.List<PriceReportMessage>): void => {

        this.popupService.open<Immutable.List<PriceReportMessage>>(PopupIdentifiers.PriceList, messages);
      },
      listenNewEventsOnly: true
    }).unsubscribeOn(this.unsubscribeSubject);

    // Stored price report message
    this.confMessageProvider.onMessagesRequest<StoredPriceReportMessage>(this.confPageSessionService.confSessionId, StoredPriceReportMessage.name, {
      next: (messages: Immutable.List<PriceReportMessage>): void => {

        this.popupService.open<Immutable.List<StoredPriceReportMessage>>(PopupIdentifiers.PriceList, messages);
      },
      listenNewEventsOnly: true
    }).unsubscribeOn(this.unsubscribeSubject);

    this.confStore.onConfigurationChange(this.configurationId, this.confSessionId, (conf: Conf) => {

      this.init();

    }).unsubscribeOn(this.unsubscribeSubject);
  }

  // Customization
  onPriceSettingsClick($event): void {
    let requestType = this.confPageSessionService.confUIStore.PageStore.getActiveClientType();
    this.confStore.getPriceSetting(this.confSessionId, this.configurationId, requestType);    
  }

  public getPriceReport(confSessionId: number, confId: number, priceListCategory?: number) {
    let requestType = this.confPageSessionService.confUIStore.PageStore.getActiveClientType();
    let model = this.confStore.createRequest(requestType);
    model.confSessionId = confSessionId;
    model.price = this.confStore.modelFactory.createRequestOrCommand<PriceCommand>(PriceCommand.name, { setPriceListCategory: priceListCategory, getPriceReport: true, configurationId: confId });

    return this.confStore.confActionCreator.dispatchGetPriceReport(model);
  }

  protected getPriceValues(conf: Conf) {
    let priceValues = conf.propertyMap.get("priceValues");
    if (priceValues)
      return priceValues.toArray();

    return [];
  }
  // End customization
}